/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { GetCurrenciesListResponse } from '../model/getCurrenciesListResponse';
import type { GetCurrencyUnitsParams } from '../model/getCurrencyUnitsParams';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of CurrencyUnits
 */
export const useGetCurrencyUnitsHook = () => {
  const getCurrencyUnits = useCustomClient<GetCurrenciesListResponse>();

  return (
    params?: GetCurrencyUnitsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getCurrencyUnits(
      { url: `/api/js/currency_units`, method: 'GET', params },
      options
    );
  };
};

export const getGetCurrencyUnitsQueryKey = (
  params?: GetCurrencyUnitsParams
) => {
  return [`/api/js/currency_units`, ...(params ? [params] : [])] as const;
};

export const useGetCurrencyUnitsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    GetCurrencyUnitsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        QueryKey,
        GetCurrencyUnitsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrencyUnitsQueryKey(params);

  const getCurrencyUnits = useGetCurrencyUnitsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    QueryKey,
    GetCurrencyUnitsParams['page']
  > = ({ pageParam }) =>
    getCurrencyUnits(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    QueryKey,
    GetCurrencyUnitsParams['page']
  > & { queryKey: QueryKey };
};

export type GetCurrencyUnitsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
>;
export type GetCurrencyUnitsInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CurrencyUnits
 */
export const useGetCurrencyUnitsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    GetCurrencyUnitsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        QueryKey,
        GetCurrencyUnitsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCurrencyUnitsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCurrencyUnitsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrencyUnitsQueryKey(params);

  const getCurrencyUnits = useGetCurrencyUnitsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
  > = () => getCurrencyUnits(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrencyUnitsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
>;
export type GetCurrencyUnitsQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CurrencyUnits
 */
export const useGetCurrencyUnits = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCurrencyUnitsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCurrencyUnitsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrencyUnitsQueryKey(params);

  const getCurrencyUnits = useGetCurrencyUnitsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
  > = () => getCurrencyUnits(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrencyUnitsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
>;
export type GetCurrencyUnitsSuspenseQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CurrencyUnits
 */
export const useGetCurrencyUnitsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCurrencyUnitsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetCurrencyUnitsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    GetCurrencyUnitsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        QueryKey,
        GetCurrencyUnitsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrencyUnitsQueryKey(params);

  const getCurrencyUnits = useGetCurrencyUnitsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    QueryKey,
    GetCurrencyUnitsParams['page']
  > = ({ pageParam }) =>
    getCurrencyUnits(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    ...queryOptions,
  } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    QueryKey,
    GetCurrencyUnitsParams['page']
  > & { queryKey: QueryKey };
};

export type GetCurrencyUnitsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>
>;
export type GetCurrencyUnitsSuspenseInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of CurrencyUnits
 */
export const useGetCurrencyUnitsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
    GetCurrencyUnitsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetCurrencyUnitsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetCurrencyUnitsHook>>>,
        QueryKey,
        GetCurrencyUnitsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetCurrencyUnitsSuspenseInfiniteQueryOptions(
    params,
    options
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
